import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { selectClasses } from "@mui/material";
import { AxiosInstance } from "../../../../axios";
import Loader from "../../Loader";
import TestPerformance from "./TestPerformance";
// import styles from "../StudentTestWorkflow/Test.module.css";
import styles from "./ClassPerformance.module.css";
import ClassPerformance from "./ClassPerformance";

// Debounce function to prevent rapid successive API calls

function ClassPerformanceTablist() {
  const { active_tab, batchIds, batch_type } = useParams();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(Number(active_tab) || 1);
  const [sortKey, setSortKey] = useState("sno");
  const [sortOrder, setSortOrder] = useState("asc");
  const [tPer, setTPer] = useState([]);
  const [tPerstatus, setTPerstatus] = useState(null);
  const [batchId, setBatchId] = useState(batchIds || null);
  const [batchType, setBatchType] = useState(batch_type || null);
  const [tabClicked, setTabClicked] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [eventName, setEeventName] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState([]);

  const [updateChipData, setUpdateChipData] = useState([]);

  const [selectedSubject, setSelectedSubject] = useState([]);
  const [selectedTestTopics, setSelectedTestTopics] = useState([]);
  console.log(selectedTestTopics, "selectedTestTopics1");

  const [subject, setSubject] = useState([]);
  const [course, setCourse] = useState([]);
  const [typeOn, setTypeOn] = useState([]);
  const [mediums, setMedium] = useState([]);
  const [methodTest, setMethodTest] = useState([]);
  const [classModes, setClassModes] = useState([]);
  const [selectedStatus, setselectedStatus] = useState([]);
  const [status, setStatus] = useState([]);
  const [test_topics, setTest_topics] = useState([]);
  const [testTopics, settestTopics] = useState([]);
  const [appOn, setAppOn] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [combineTest, setCombineTest] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [dateFilter, setDateFilter] = useState({
    FDate: "",
    TDate: "",
  });
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const location = useLocation();
  const {
    filStatus,
    fillEventNames,
    fillSubject,
    fillAppOn,
    fillTestTopics,
    fillSearch,
  } = location.state || {};
  console.log(fillSubject, "APPON", fillAppOn);

  const userJSON = sessionStorage.getItem("userDetails");
  const userid = userJSON ? JSON.parse(userJSON)?.user_id : null;
  const isMounted = useRef(true);
  const abortControllerRef = useRef(new AbortController());
  const isInitialMount = useRef(true);
  const filterEventRef = useRef(null);
  const filterDateRef = useRef(null);
  const filterSubjectRef = useRef(null);
  const filterTestTopicRef = useRef(null);
  const filterStatusRef = useRef(null);
  const txtBSearch = useRef(null);
  // Clean up on unmount
  useEffect(() => {
    if (batchId) {
      setIsLoading(true); // start loading

      const timer = setTimeout(async () => {
        try {
          await loadListdata(); // wait until API/data load finishes
        } finally {
          setIsLoading(false); // stop loading
        }
      }, 1000);

      return () => clearTimeout(timer); // cleanup
    }
  }, [batchId, updateChipData]);

  const handleView = (event_id, batch_id, statuses, event_type, type_batch) => {
    navigate(
      `/ViewTestDetail/${batch_id}/${event_id}/${statuses}/${event_type}/${type_batch}/1`,
      {
        state: {
          STATUS: selectedStatus,
          EVENTNAMES: selectedEvent,
          SUBJECT: selectedSubject,
          TESTTOPICS: selectedTestTopics,
          APPON: appOn,
          EVENTTYPE: 0,
          ACTIVETAB: activeTab,
          BATCHIDS: batchId,
          SEARCHTERM: searchTerm,
          DATEFILTER: dateFilter,
          APPDATA: appData,
        },
      }
    );
  };

  // useEffect(() => {
  //   if (location.state && isInitialMount.current) {
  //     const {
  //       filStatus,
  //       fillEventNames,
  //       fillSubject,
  //       fillTestTopics,
  //       fillTQMarks,
  //       fillAppOn,
  //       fillActiveTab,
  //       fillBatchId,
  //       fillBatchType,
  //       fillSearch,
  //       DATEFILTER,
  //       APPDATA,
  //     } = location.state;

  //     // Restore all filter states
  //     setselectedStatus(filStatus || []);
  //     setSelectedEvent(fillEventNames || []);
  //     setSelectedSubject(fillSubject || []);
  //     setSelectedToppics(fillTestTopics || []);
  //     setSearchTerm(fillSearch || "");

  //     // Restore date filter states
  //     if (DATEFILTER) {
  //       setDateFilter(DATEFILTER);
  //     }

  //     // Restore marks filter
  //     if (fillTQMarks) {
  //       setInitialfields({
  //         fromDate: fillTQMarks.fromDate || "",
  //         toDate: fillTQMarks.toDate || "",
  //       });
  //     }

  //     if (fillAppOn.length > 0) {
  //       setAppData({
  //         FDate: fillAppOn[0].fdate,
  //         TDate: fillAppOn[0].edate,
  //         Days: fillAppOn[0].Days,
  //         name: fillAppOn[0].name,
  //       });

  //       setAppOn(fillAppOn || []);
  //     }

  //     // Generate updateChipData array
  //     const chipData = [];

  //     // Status chips
  //     if (filStatus?.length > 0) {
  //       filStatus.forEach((item) => {
  //         chipData.push({ type: item.type, id: item.id, name: item.name });
  //       });
  //     }

  //     // Event name chips
  //     if (fillEventNames?.length > 0) {
  //       fillEventNames.forEach((item) => {
  //         chipData.push({ type: item.type, id: item.id, name: item.name });
  //       });
  //     }

  //     // Subject chips
  //     if (fillSubject?.length > 0) {
  //       fillSubject.forEach((item) => {
  //         chipData.push({ type: item.type, id: item.id, name: item.name });
  //       });
  //     }

  //     // Test topic chips
  //     if (fillTestTopics?.length > 0) {
  //       fillTestTopics.forEach((item) => {
  //         chipData.push({ type: item.type, id: item.id, name: item.name });
  //       });
  //     }

  //     // Applied on chips (date range)
  //     if (fillAppOn?.length > 0) {
  //       fillAppOn.forEach((item) => {
  //         chipData.push({
  //           type: item.type,
  //           id: item.id,
  //           name: item.name,
  //           fdate: item.fdate,
  //           edate: item.edate,
  //         });
  //       });
  //     }

  //     // Total marks chips
  //     if (fillTQMarks && (fillTQMarks.fromDate || fillTQMarks.toDate)) {
  //       chipData.push({
  //         type: "tot_marks",
  //         name: `${fillTQMarks.fromDate || ""} - ${fillTQMarks.toDate || ""}`,
  //         value: "tot_marks",
  //       });
  //     }

  //     // Search term chip
  //     if (fillSearch) {
  //       chipData.push({
  //         type: "search",
  //         name: `${fillSearch}`,
  //         value: fillSearch,
  //       });
  //     }

  //     // Date filter chips (if present in DATEFILTER)
  //     if (DATEFILTER && (DATEFILTER.FDate || DATEFILTER.TDate)) {
  //       chipData.push({
  //         type: "dateFilter",
  //         name: `${DATEFILTER.FDate || ""} - ${DATEFILTER.TDate || ""}`,
  //         value: "dateFilter",
  //       });
  //     }

  //     setUpdateChipData(chipData);

  //     // Restore active tab
  //     if (fillActiveTab !== undefined) {
  //       setActiveTab(fillActiveTab);
  //     }

  //     // Restore batch selection
  //     if (fillBatchId) {
  //       const matchingBatch = tPer.find(
  //         (batch) => batch.batch_id === fillBatchId
  //       );
  //       if (matchingBatch) {
  //         setBatchId(matchingBatch.batch_id);
  //         setBatchType(matchingBatch.batch_type);
  //       } else {
  //         setBatchId(fillBatchId);
  //         if (fillBatchType && fillBatchType !== "undefined") {
  //           setBatchType(fillBatchType);
  //         }
  //       }
  //     }

  //     isInitialMount.current = false;
  //   }
  // }, [location.state, tPer]);
  const [isOpen, setIsopen] = useState({
    eventName: false,
    subject: false,
    tot_marks: false,
    appliedOn: false,
    status: false,
    testTopic: false,
  });
  console.log(isOpen, "isOpen");

  let filterSearch = [];
  let filterEvent = [];

  let filterTestTopic = [];
  let filterApplyeds = [];
  let filterStatus = [];
  let filterSubject = [];
  // Initial data fetch
  useEffect(() => {
    if (!userid) return;

    const fetchInitialData = async () => {
      if (isLoading) return;

      // setIsLoading(true);
      abortControllerRef.current = new AbortController();

      try {
        const batchResponse = await AxiosInstance.post(
          "api/batch/list/byUser",
          { user_id: userid },
          { signal: abortControllerRef.current.signal }
        );

        if (
          batchResponse.data?.status === true &&
          Array.isArray(batchResponse.data?.data)
        ) {
          const batches = batchResponse.data.data;
          setTPer(batches);
          setTPerstatus(batchResponse.data?.view_performer);

          const initialBatch =
            (!batchIds || batchIds === "null") && batches.length > 0
              ? batches[0]
              : null;

          if (initialBatch) {
            setBatchId(initialBatch.batch_id);
            setBatchType(initialBatch.batch_type);
            setActiveTab(1);
          }
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Error fetching data:", error);
        }
      } finally {
        if (isMounted.current) {
          setIsLoading(false);
        }
      }
    };

    fetchInitialData();
  }, [userid]);

  // Main API call effect

  // Debounced fetch function
  // Debounced fetch function
  function loadListdata() {
    const dateChip = updateChipData.find(
      (chip) => chip?.type === "dayRange" || chip?.type === "dateRange"
    );
    const startDate = dateChip?.fdate || "";
    const endDate = dateChip?.edate || "";
    let tempEvent = [];
    let tempSubject = [];
    let tempTestTopic = [];
    let tempStatus = [];
    selectedEvent.map((obj) => {
      tempEvent.push(obj.id);
    });
    selectedStatus.map((obj) => {
      tempStatus.push(obj.id);
    });
    selectedSubject.map((obj) => {
      tempSubject.push(obj.id);
    });
    selectedTestTopics.map((obj) => {
      tempTestTopic.push(obj.id);
    });
    const payload = {
      batch_id: batchId,
      user_id: userid,
      start_date: startDate,
      end_date: endDate,

      event: selectedEvent.length > 0 ? tempEvent : "",
      status:
        selectedStatus.length > 0
          ? selectedStatus.map((obj) => Number(obj.id))
          : "",
      subject: selectedSubject.map((s) => s.id).join(","),
      test_topic: selectedTestTopics.length > 0 ? tempTestTopic : "",
      search: searchTerm.length > 0 ? searchTerm : "",
      start_no_of_que: "",
      end_no_of_que: "",
      start_tot_marks: initialfields.fromDate,
      end_tot_marks: initialfields.toDate,
      start_marks_obtained: "",
      end_marks_obtained: "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/test/report/class_list/byUser", payload).then(
      (response) => {
        setIsLoading(false);
        if (
          response.data.status === true &&
          Array.isArray(response.data.data)
        ) {
          const el = response.data.data;

          // Handle flat array (no single_exam/combined_exam)
          const fiata = Array.isArray(el)
            ? el.map((item) => ({
                ...item,
                type: item.type === 1 ? "combined_exam" : "single_exam", // fallback
              }))
            : [];

          // CSV data
          const csvFormattedData = fiata.map((item, index) => ({
            serialNumber: index + 1,
            description: item.event_name || item.exam_name || "",
            url: "",
            category_name: Array.isArray(item.subject)
              ? item.subject.map((s) => s.subject).join(", ")
              : "",
            displayDate: item.start_date
              ? moment(item.start_date).format("DD/MM/YYYY")
              : "",
            status: Number(item.status) === 1 ? "Completed" : "Absent",
          }));
          setCsvData(csvFormattedData);

          //  Split into single / combined
          const singleExams = fiata.filter((el) => el.type === "single_exam");
          const combinedExams = fiata.filter(
            (el) => el.type === "combined_exam"
          );

          setReportData(singleExams);
          setCombineTest(combinedExams);

          //  Event names
          const eeventSet = fiata.flatMap((event) =>
            event.event_name
              ? [{ event_name: event.event_name, event_pk: event.event_pk }]
              : []
          );

          //  Unique subjects
          const subjectSet = fiata.flatMap((event) => event.subject || []);
          const uniqueSubjects = Array.from(
            new Map(
              subjectSet
                .filter((subj) => subj && subj.subject)
                .map((subj) => [subj.subject.toLowerCase(), subj])
            ).values()
          );

          //  Unique topics
          const testtopicSet = fiata.flatMap((event) => event.test_topic || []);
          const uniqueTestTopics = Array.from(
            new Map(
              testtopicSet
                .filter((topic) => topic && topic.test_topic)
                .map((topic) => [topic.test_topic.toLowerCase(), topic])
            ).values()
          );
          setEeventName(eeventSet);
          setSubject(uniqueSubjects);
          settestTopics(uniqueTestTopics);
        } else {
          setCombineTest([]);
          setReportData([]);
        }
      }
    );
    // Fixed success check
  }

  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  // Process data function remains the same
  const processData = (data) => {
    const structuredData = [];

    if (data.single_exam && data.single_exam.length) {
      data.single_exam.forEach((exam) => {
        structuredData.push({
          ...exam,
          type: "single_exam",
        });
      });
    }

    if (data.combined_exam && data.combined_exam.length) {
      data.combined_exam.forEach((combined) => {
        const combinedExamGroup = {
          exam_name: combined.exam_name,
          tot_marks: combined.tot_marks,
          marks_obtained: combined.marks_obtained,
          cut_off: combined.cut_off,
          event_rank: combined.event_rank,
          over_all_event_rank: combined.over_all_event_rank,
          exam_data: [],
          type: "combined_exam",
        };

        combined.exam_data.forEach((exam) => {
          combinedExamGroup.exam_data.push({
            ...exam,
            type: "single_exam",
          });
        });

        structuredData.push(combinedExamGroup);
      });
    }

    return structuredData;
  };

  useEffect(() => {
    filterSubject = selectedSubject;
  }, [selectedSubject]);
  useEffect(() => {
    filterTestTopic = selectedTestTopics;
  }, [selectedTestTopics]);
  useEffect(() => {
    filterEvent = selectedEvent;
  }, [selectedEvent]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isInsideFilterBox = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");

      // Don’t close if interacting with checkboxes, filter popups, or chips
      if (isCheckbox || isInsideFilterBox || isChipData) return;

      // Event Name filter
      if (
        filterEventRef.current &&
        !filterEventRef.current.contains(event.target)
      ) {
        const hasEvent = updateChipData.some(
          (chipItem) => chipItem.type === "event"
        );
        setSelectedEvent(
          hasEvent
            ? updateChipData.filter((chipItem) => chipItem.type === "event")
            : []
        );
        setIsopen((prev) => ({ ...prev, eventName: false }));
      }

      // Applied On (Date) filter
      if (
        filterDateRef.current &&
        !filterDateRef.current.contains(event.target)
      ) {
        const dayChip = updateChipData.find(
          (chipItem) => chipItem.Days && chipItem.Days === appData.Days
        );
        const dateChip = updateChipData.find(
          (chipItem) =>
            chipItem.fdate === appData.FDate && chipItem.edate === appData.TDate
        );

        if (dayChip) {
          setAppData({ FDate: "", TDate: "", Days: dayChip.Days });
          setAppOn([{ FDate: "", TDate: "", Days: dayChip.Days }]);
        } else if (dateChip) {
          setAppData({
            FDate: dateChip.fdate,
            TDate: dateChip.edate,
            Days: "",
          });
          setAppOn([
            { FDate: dateChip.fdate, TDate: dateChip.edate, Days: "" },
          ]);
        } else {
          setAppData({ FDate: "", TDate: "", Days: "" });
          setAppOn([]);
        }

        setIsopen((prev) => ({ ...prev, appliedOn: false }));
      }

      // Subject filter
      if (
        filterSubjectRef.current &&
        !filterSubjectRef.current.contains(event.target)
      ) {
        const hasSubject = updateChipData.some(
          (chipItem) => chipItem.type === "subject"
        );
        setSelectedSubject(
          hasSubject
            ? updateChipData.filter((chipItem) => chipItem.type === "subject")
            : []
        );
        setIsopen((prev) => ({ ...prev, subject: false }));
      }

      // Test Topic filter
      if (
        filterTestTopicRef.current &&
        !filterTestTopicRef.current.contains(event.target)
      ) {
        const hasTestTopic = updateChipData.some(
          (chipItem) => chipItem.type === "testTopic"
        );
        setSelectedTestTopics(
          hasTestTopic
            ? updateChipData.filter((chipItem) => chipItem.type === "testTopic")
            : []
        );
        setIsopen((prev) => ({ ...prev, testTopic: false }));
      }

      // Status filter
      if (
        filterStatusRef.current &&
        !filterStatusRef.current.contains(event.target)
      ) {
        const hasStatus = updateChipData.some(
          (chipItem) => chipItem.type === "status"
        );
        setStatus(
          hasStatus
            ? updateChipData.filter((chipItem) => chipItem.type === "status")
            : []
        );
        setIsopen((prev) => ({ ...prev, status: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, appData]);

  useEffect(() => {
    if (fillEventNames && fillEventNames.length > 0) {
      setSelectedEvent(fillEventNames);
      filterEvent = fillEventNames;
    } else {
      setSelectedEvent(selectedEvent);
      filterEvent = selectedEvent;
    }
    if (fillAppOn && fillAppOn.length > 0) {
      const filterDates = fillAppOn[0];
      setAppData({
        FDate: filterDates.fdate,
        TDate: filterDates.edate,
        Days: filterDates.Days,
        name: "",
      });
      setAppOn(fillAppOn);
      filterApplyeds = fillAppOn;
    }
    if (fillSubject && fillSubject.length > 0) {
      setSelectedSubject(fillSubject);
      filterSubject = fillSubject;
    } else {
      setSelectedSubject(selectedSubject);
      filterSubject = selectedSubject;
    }
    if (fillTestTopics && fillTestTopics.length > 0) {
      setSelectedTestTopics(fillTestTopics);
      filterTestTopic = fillTestTopics;
    } else {
      setSelectedTestTopics(selectedTestTopics);
      filterTestTopic = selectedTestTopics;
    }
    if (filStatus && filStatus.length > 0) {
      setselectedStatus(filStatus);
      filterStatus = filStatus;
    } else {
      setselectedStatus(selectedStatus);
      filterStatus = selectedStatus;
    }
    if (fillSearch && fillSearch.length > 0) {
      filterSearch = [{ name: "" + fillSearch, type: "search" }];
      setSearchTerm(fillSearch);
    } else {
      if (searchTerm) {
        setSearchTerm(searchTerm);
        filterSearch = [{ name: "" + searchTerm, type: "search" }];
      }
    }
    loadChipdata();
  }, [filStatus, fillSearch]);
  function updateStateData() {
    filterEvent = selectedEvent;
    filterApplyeds = appOn;
    filterSubject = selectedSubject;
    filterTestTopic = selectedTestTopics;
    filterStatus = selectedStatus;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }
  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterEvent.map((obj) => {
      tempArr.push(obj);
    });
    filterSubject.map((obj) => {
      tempArr.push(obj);
    });
    filterTestTopic.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyeds.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }
  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "eventName") {
      loadChipdata();
      setIsopen({
        ...isOpen,
        eventName: false,
      });
    } else if (name === "subject") {
      loadChipdata();
      setIsopen({
        ...isOpen,
        subject: false,
      });
    } else if (name === "test_topic") {
      loadChipdata();
      setIsopen({
        ...isOpen,
        testTopic: false,
      });
    } else if (name === "startDate") {
      loadChipdata();
      setIsopen({
        ...isOpen,
        appliedOn: false,
      });
    } else if (name === "status") {
      loadChipdata();
      setIsopen({
        ...isOpen,
        status: false,
      });
    }
  };
  // Tab click handler
  const handleTabClick = (index, batch_id, batch_type) => {
    if (isLoading) return;

    if (activeTab !== index) {
      setSelectedEvent([]);
      setSelectedSubject([]);
      setselectedStatus([]);
      setSelectedTestTopics([]);
      setAppOn([]);
      setSearchTerm("");
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      });
      setUpdateChipData([]);
    }

    setTabClicked(true);
    setActiveTab(index);
    setBatchId(batch_id);
    setBatchType(batch_type);
  };

  // Date change handlers (unchanged from original)
  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };

        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  //   const handleFilterSearch = (event, names) => {
  //   console.log(names,"namesnames");

  //   if (names == "eventName") {
  //     const searchInput = event.target.value;
  //     if (searchInput !== "") {
  //       const matchingObjects = eventName.filter(
  //         (item) =>
  //           item.event_name &&
  //           item.event_name.toLowerCase().includes(searchInput.toLowerCase())
  //       )

  //       setEeventName(matchingObjects);
  //     } else {
  //       setEeventName(eventName);
  //     }
  //   }
  // };
  const handleFilterSearch = (event, names) => {
    const searchInput = event.target.value.toLowerCase();

    if (names === "eventName") {
      if (searchInput !== "") {
        const matchingObjects = eventName.filter(
          (item) =>
            item.event_name &&
            item.event_name.toLowerCase().includes(searchInput)
        );
        setEeventName(matchingObjects);
      } else {
        setEeventName(eventName);
      }
    } else if (names === "subject") {
      if (searchInput !== "") {
        const matchingSubjects = subject.filter(
          (item) =>
            item.subject && item.subject.toLowerCase().includes(searchInput)
        );
        setSubject(matchingSubjects);
      } else {
        // Reset to original subject list when search is cleared
        // You might want to maintain the original list in a separate state if needed
        const uniqueSubjects = Array.from(
          new Map(
            reportData
              .flatMap((event) => event.subject || [])
              .filter((subj) => subj && subj.subject)
              .map((subj) => [subj.subject.toLowerCase(), subj])
          ).values()
        );
        setSubject(uniqueSubjects);
      }
    }
  };

  const handleAppliedOn = (e) => {
    const { name, value, checked } = e.target;

    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "",
        };

        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        } else {
          setAppOn([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        setAppData({
          FDate: "",
          TDate: "",
          Days: value,
        });

        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";

        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }

        setAppOn([
          {
            name: label,
            fdate,
            edate,
            type: "dayRange",
            Days: value,
          },
        ]);
      }
    }
  };

  // Checkbox handler (unchanged)
  // Checkbox handler

  const handleCheckboxChange = (event, typename) => {
    const { value, checked, name } = event.target;
    console.log(typename, "typename");

    if (typename === "eventName") {
      if (checked) {
        setSelectedEvent([
          ...selectedEvent,
          { id: value, name: name, type: "eventName" },
        ]);
      } else {
        setSelectedEvent(selectedEvent.filter((item) => item.id !== value));
      }
    }
    if (typename === "subject") {
      if (checked) {
        setSelectedSubject([
          ...selectedSubject,
          { id: value, name: name, type: "subject" },
        ]);
      } else {
        setSelectedSubject(selectedSubject.filter((item) => item.id !== value));
      }
    }
    if (typename === "test_topic") {
      if (checked) {
        setSelectedTestTopics([
          ...selectedTestTopics,
          { id: value, name: name, type: "test_topic" },
        ]);
      } else {
        setSelectedTestTopics(
          selectedTestTopics.filter((item) => item.id !== value)
        );
      }
    }
    // else if (typename === "subject") {
    //   if (checked) {
    //     setS([
    //       ...publisher_name,
    //       { id: value, name: name, type: "subject" },
    //     ]);
    //   } else {
    //     setPublisher_name(publisher_name.filter((item) => item.id !== value));
    //   }
    // } else if (typename === "visible_to_user") {
    //   if (checked) {
    //     setVisible_to_user([
    //       { id: value, name: name, type: "visible_to_user" },
    //     ]);
    //   } else {
    //     setVisible_to_user(visible_to_user.filter((item) => item.id !== value));
    //   }
    // } else if (typename === "category") {
    //   if (checked) {
    //     setCategory_on([
    //       ...category_on,
    //       { id: value, name: name, type: "category" },
    //     ]);
    //   } else {
    //     setCategory_on(category_on.filter((item) => item.id !== value));
    //   }
    // } else if (typename === "course") {
    //   if (checked) {
    //     setCourse_on([...course_on, { id: value, name: name, type: "course" }]);
    //   } else {
    //     setCourse_on(course_on.filter((item) => item.id !== value));
    //   }
    // } else if (typename === "subject") {
    //   if (checked) {
    //     setSubject_on([
    //       ...subject_on,
    //       { id: value, name: name, type: "subject" },
    //     ]);
    //   } else {
    //     setSubject_on(subject_on.filter((item) => item.id !== value));
    //   }
    // } else if (typename === "medium") {
    //   if (checked) {
    //     setMedium_on([...medium_on, { id: value, name: name, type: "medium" }]);
    //   } else {
    //     setMedium_on(medium_on.filter((item) => item.id !== value));
    //   }
    // } else if (typename === "seriesTag") {
    //   if (checked) {
    //     setSeries_on([
    //       ...series_on,
    //       { id: value, name: name, type: "seriesTag" },
    //     ]);
    //   } else {
    //     setSeries_on(series_on.filter((item) => item.id !== value));
    //   }
    // } else if (typename === "freeBook") {
    //   if (checked) {
    //     setFreeBook([{ id: value, name: name, type: "freeBook" }]);
    //   } else {
    //     setFreeBook(freeBook.filter((item) => item.id !== value));
    //   }
    // } else if (typename === "eBook") {
    //   if (checked) {
    //     setEBook([{ id: value, name: name, type: "eBook" }]);
    //   } else {
    //     setEBook(eBook.filter((item) => item.id !== value));
    //   }
    // }
  };
  // Sort handler
  const handleSort = useCallback(
    (key) => {
      const order = sortKey === key && sortOrder === "asc" ? "desc" : "asc";
      setSortKey(key);
      setSortOrder(order);
    },
    [sortKey, sortOrder]
  );

  // Sorted data
  // const sortedReportData = useMemo(() => {
  //   return [...reportData].sort((a, b) => {
  //     let valA = a[sortKey] ?? "";
  //     let valB = b[sortKey] ?? "";
  //     const isNumber = !isNaN(valA) && !isNaN(valB);

  //     if (isNumber) return sortOrder === "asc" ? valA - valB : valB - valA;

  //     return sortOrder === "asc"
  //       ? valA.toString().localeCompare(valB.toString())
  //       : valB.toString().localeCompare(valA.toString());
  //   });
  // }, [reportData, sortKey, sortOrder]);

  const sortedReportData = useMemo(() => {
    return [...reportData].sort((a, b) => {
      let valA, valB;

      // Handle subject sorting
      if (sortKey === "subject") {
        valA = a.subject?.map((s) => s.subject).join(", ") || "";
        valB = b.subject?.map((s) => s.subject).join(", ") || "";
      }
      // Handle test topic sorting
      else if (sortKey === "test_topic") {
        valA = a.test_topic?.map((t) => t.test_topic).join(", ") || "";
        valB = b.test_topic?.map((t) => t.test_topic).join(", ") || "";
      }
      // Default case for other fields
      else {
        valA = a[sortKey] ?? "";
        valB = b[sortKey] ?? "";
      }

      const isNumber = !isNaN(valA) && !isNaN(valB);

      if (isNumber) return sortOrder === "asc" ? valA - valB : valB - valA;

      return sortOrder === "asc"
        ? valA.toString().localeCompare(valB.toString())
        : valB.toString().localeCompare(valA.toString());
    });
  }, [reportData, sortKey, sortOrder]);

  // Filter chip deletion
  const handleDelete = (chipToDelete, index) => () => {
    if (chipToDelete.type === "eventName") {
      setSelectedEvent(
        selectedEvent.filter((event) => event.id !== chipToDelete.id)
      );
    }
    if (chipToDelete.type === "tot_marks") {
      setInitialfields({ fromDate: "", toDate: "" });
    } else if (chipToDelete.type === "subject") {
      setSelectedSubject(
        selectedSubject.filter((subject) => subject.id !== chipToDelete.id)
      );
    } else if (chipToDelete.type === "test_topic") {
      setSelectedTestTopics(
        selectedTestTopics.filter((topic) => topic.id !== chipToDelete.id)
      );
    } else if (chipToDelete.type === "status") {
      setselectedStatus(
        selectedStatus.filter((status) => status.id !== chipToDelete.id)
      );
    } else if (
      chipToDelete.type === "dayRange" ||
      chipToDelete.type === "dateRange"
    ) {
      setAppOn([]);
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      });
    } else if (chipToDelete.type === "search") {
      setSearchTerm("");
    }

    setUpdateChipData(updateChipData.filter((chip, i) => i !== index));
  };
  const handleAllClear = () => {
    setSearchTerm([]);
    setUpdateChipData([]);
    setSelectedEvent([]);
    setSelectedSubject([]);
    setSelectedTestTopics([]);
    setselectedStatus([]);
    loadListdata();
    setAppOn([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
    });
  };
  const [initialfields, setInitialfields] = useState({
    fromDate: "",
    toDate: "",
  });

  const handleClear = (filterType) => {
    if (filterType === "tot_marks") {
      setInitialfields({});
      setIsopen((prev) => ({ ...prev, tot_marks: false }));
      setUpdateChipData((prev) =>
        prev.filter((chip) => chip.type !== "tot_marks")
      );
    }
    if (filterType === "all") {
      setInitialfields({});
      setSelectedEvent([]);
      setSelectedSubject([]);
      setSelectedTestTopics([]);
      setselectedStatus([]);
      setAppOn([]);
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      });
      setSearchTerm("");
      setUpdateChipData([]);
      setIsopen({
        eventName: false,
        subject: false,
        tot_marks: false,
        appliedOn: false,
        status: false,
      });
    } else if (filterType === "search") {
      setSearchTerm("");
      setUpdateChipData((prev) =>
        prev.filter((chip) => chip.type !== "search")
      );
    } else {
      switch (filterType) {
        case "eventName":
          setSelectedEvent([]);
          setUpdateChipData((prev) =>
            prev.filter((chip) => chip.type !== "eventName")
          );
          setIsopen((prev) => ({ ...prev, eventName: false }));
          break;
        case "subject":
          setSelectedSubject([]);
          setUpdateChipData((prev) =>
            prev.filter((chip) => chip.type !== "subject")
          );
          setIsopen((prev) => ({ ...prev, subject: false }));
          break;
        case "test_topic":
          setSelectedTestTopics([]);
          setUpdateChipData((prev) =>
            prev.filter((chip) => chip.type !== "test_topic")
          );
          setIsopen((prev) => ({ ...prev, testTopic: false }));
          break;
        case "status":
          setselectedStatus([]);
          setUpdateChipData((prev) =>
            prev.filter((chip) => chip.type !== "status")
          );
          setIsopen((prev) => ({ ...prev, status: false }));
          break;
        case "startDate":
          setAppOn([]);
          setAppData({
            FDate: "",
            TDate: "",
            Days: "",
            name: "",
          });
          setUpdateChipData((prev) =>
            prev.filter(
              (chip) => chip.type !== "dayRange" && chip.type !== "dateRange"
            )
          );

          setIsopen((prev) => ({ ...prev, appliedOn: false }));
          break;
        default:
          break;
      }
    }
  };

  // Date filter change
  const handleDateFilterChange = (newFilter) => {
    setDateFilter(newFilter);
  };
  const handleMarksChange = (event) => {
    let { name, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className={`BathHeader`}>
      <div className="col-md-6 col-12">
        <h2 className="TitleHeader">Class Performance</h2>
      </div>

      <div className="row mt-3">
        <div className="col-md-12 ">
          <ul
            className={`nav cm_nav-fill mb-3 ${styles.listViewTabs}`}
            id="cm_listViewTabs"
            role="tablist"
          >
            {tPer.length > 0 ? (
              tPer.map((el, index) => (
                <li className="nav-item" role="presentation" key={el.batch_id}>
                  <a
                    className={
                      activeTab === index + 1 ? "nav-link active" : "nav-link"
                    }
                    href="#"
                    role="tab"
                    aria-selected={activeTab === index + 1}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTabClick(index + 1, el.batch_id, el.batch_type);
                    }}
                  >
                    {el.batch_name}
                  </a>
                </li>
              ))
            ) : (
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active"
                  href="javascript:void(0)"
                  role="tab"
                >
                  NO BATCH FOUND
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div>
        <ClassPerformance
          reportData1={combineTest}
          reportData={sortedReportData}
          onSort={handleSort}
          eventName={eventName}
          selectedEvent={selectedEvent}
          subject={selectedSubject}
          selectetSubject={selectedSubject}
          testTopics={testTopics}
          selectedTestTopics={selectedTestTopics}
          setSelectedEvent={setSelectedEvent}
          handleCheckboxChange={handleCheckboxChange}
          handleApplyFilter={handleApplyFilter}
          selectedSubject={selectedSubject}
          setSelectedSubject={setSelectedSubject}
          status={status}
          setselectedStatus={setselectedStatus}
          settestTopics={settestTopics}
          dateFilter={dateFilter}
          handleDateFilterChange={handleDateFilterChange}
          isOpen={isOpen}
          handleChange={handleMarksChange}
          initialfields={initialfields}
          setIsopen={setIsopen}
          handleDelete={handleDelete}
          appData={appData}
          setAppData={setAppData}
          updateChipData={updateChipData}
          handleFilterSearch={handleFilterSearch}
          appOn={appOn}
          setAppOn={setAppOn}
          batchId={batchId}
          batchType={batchType}
          activeTab={activeTab}
          handleAppliedOn={handleAppliedOn}
          handleClear={handleClear}
          handleChangeDate={handleChangeDate}
          selectedStatus={selectedStatus}
          IsLoading={isLoading}
          setIsLoading={setIsLoading}
          handleView={handleView}
          // debouncedSearch={debouncedSearch}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          handleSearch={handleSearch}
          txtBSearch={txtBSearch}
          handleSearchFocus={handleSearchFocus}
          handleAllClear={handleAllClear}
        />
      </div>
    </div>
  );
}

export default ClassPerformanceTablist;
